/** Used for people without a preferred office, and for offices without a valid timezone. */
export const DEFAULT_TIMEZONE = 'UTC';

/** The IANA timezone itself when the runtime knows it, otherwise UTC. */
export function resolveTimeZone(timeZone: unknown): string {
  if (typeof timeZone !== 'string' || !timeZone.trim()) return DEFAULT_TIMEZONE;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: timeZone.trim() });
    return timeZone.trim();
  } catch {
    return DEFAULT_TIMEZONE;
  }
}
